<mat-icon style="position: relative; top: -12px; left: 12px; cursor: pointer;" class="right" matDialogClose>close</mat-icon>
<h1>Which party did not show up for the consultation?</h1>
<div style="display: flex; justify-content: center;">
  <div style="display: inline-flex; justify-content: space-evenly;">
    <button mat-button (click)="partySelected('parent')">Parent</button>
    <button mat-button (click)="partySelected('expert')">Expert</button>
  </div>
</div>
